// extracted by mini-css-extract-plugin
export default {"container":"LY52m","label":"x4Kmw","offLabel":"k32Gx","toggle":"EQhE_","onLabel":"c1gHs"};